var $ = require("jquery");
import moment from "moment/moment.js";
$(document).on('turbo:load', function () {
  if ($("#all-search").length > 0 && $("#all-search").val() !== '') {
    $("#search-results").append(`<div class="row mt-3"><div class="col-12 justify-content-center text-center"><div class="spinner-border text-primary text-center" role="status"></div></div></div>`);
    searchAll($("#all-search").val());
  }
  let timeout = null;
  $('body').on("keyup", '#all-search', function () {
    clearTimeout(timeout);
    $("#search-results").empty();
    $("#total-searched-items").text("");
    $("#search-results").append(`<div class="row mt-3"><div class="col-12 justify-content-center text-center"><div class="spinner-border text-primary text-center" role="status"></div></div></div>`);
    timeout = setTimeout(function () {
      let search_text = document.getElementById("all-search").value
      search_text != "" && searchAll(search_text);
      search_text == "" && $("#search-results").empty();
    }, 500);

  });
  $(document).on("click", "a[data-srcbtn]", function () {
    $(`#search-results li[data-type='${$(this).data('id')}']`).each(function (index) {
      $(this).removeClass("d-none");
    });
    $(document).on("click", "a[data-srcbtn]", function () {
      $(`#search-results li[data-type='${$(this).data('id')}']`).each(function (index) {
        $(this).removeClass("d-none");
      });
      $(this).empty();
    });
    $(this).empty();
  });
  $("#left-menu-search-btn").click(function () {
    let search_text_ = $("#left-menu-search-input").val();
    if (search_text_ !== '') {
      Turbo.visit('/search?search_text=' + search_text_, { action: 'replace' })
      return;
    }
  });
  $('#left-menu-search-input').keypress(function (e) {
    var key = e.which;
    if (key == 13) {
      $('#left-menu-search-btn').click();
      return false;
    }
  });

  if ($("#date-range-search").length > 0) {
    if (typeof $.fn.daterangepicker === 'function') {
      $("#date-range-search").daterangepicker({
        opens: 'left',
        drops: 'down',
        locale: {
          format: "DD.MM.YYYY",
          separator: " - ",
          applyLabel: "Speichern",
          cancelLabel: "Löschen",
          fromLabel: "From",
          toLabel: "To",
          customRangeLabel: "Custom",
          weekLabel: "W",
          daysOfWeek: [
            'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'
          ],
          monthNames: [
            "Januar",
            "Februar",
            "M&auml;rz",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember"
          ],
          firstDay: 1
        },
        applyButtonClasses: "btn-secondary text-white",
      }, function (start, end, label) {
        $("#search-results li").each(function (index) {
          let published_ = Date.parse($("#search-results li")[index].getAttribute("data-published"));
          if (published_ <= end.format('x') &&
            published_ >= start.format('x')) {
            if ($("#search-results li")[index].classList.contains('thatClass')) {
              $("#search-results li")[index].classList.remove("d-none");
            }
          } else {
            $("#search-results li")[index].classList.add("d-none");
          }

        });
        // console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
      });
    } else {
      console.error('daterangepicker is unavailable on #date-range-search');
    }
  }
  $('input#date-range-search').val('Auswählen');
});
async function searchAll(searchText) {
  let suggestions = await getSuggestions(searchText);
  let current_ort_id = JSON.parse(window.localStorage.getItem("current_city_id"));
  $("#search-results").empty();
  $("#total-searched-items").text(`${suggestions.data.pagination.total_entries} Ergebnisse gefunden`);
  let filteredData = [];
  $("#search-filter").change(function () {
    $("#search-results").empty();
    let filter_key = $("#search-filter").val();
    if (filter_key === 'all') {
      filteredData = suggestions.data.data
    } else {
      filteredData = suggestions.data.data.filter(i => i.kind === filter_key)
    }
    $("#total-searched-items").text(`${filteredData.length} ${$("#search-filter option:selected").text()} gefunden`);
    $.each(filteredData, function (key, value) {
      var link_to = "";
      switch (value.kind) {
        case "Artikel":
          link_to = `/neues/${value.lw_id}?ort=${current_ort_id}`
          break;
        case "Poi":
          link_to = `/entdecken/all/${value.lw_id}`
          break;
        case "Job":
          link_to = `/stellenangebote/${value.lw_id}`
          break;
        case "Veranstaltung":
          link_to = `/events/${value.lw_id}`
          break;
      }
      $("#search-results").append(`<li class="row mt-3" data-count="${key}" data-type="${value.kind}" data-published="${value.publication_date}">
    <a class="align-items-center d-flex link-dark text-decoration-none" href="${link_to}"><div class="col-10">
    <p class="fs-small mb-0 ps-2 pt-1 text-black-50">${value.header}</p>
    <p class="mb-0 ps-2 fw-bold">${value.title}</p>
    </div>
    <div class="col-2 d-flex justify-content-end pe-0">
    <div class="icon-arrow-right-1 text-default-gray"></div>
    </div>
    </a>
    </li>`);
    });
  });
  const grouped = groupBy(suggestions.data.data, "kind");
  $.each(grouped, function (key, value) {
    var item_type = "";
    var link_to = "";
    var link_text = "";
    var item_count;
    switch (key) {
      case "Artikel":
        item_type = `Nachrichten`
        item_count = grouped[key].length
        break;
      case "Poi":
        item_type = `Einträge unter „Entdecken“`
        item_count = grouped[key].length
        break;
      case "Job":
        item_type = `Jobs`
        item_count = grouped[key].length
        break;
      case "Veranstaltung":
        item_type = `Events`
        item_count = grouped[key].length
        break;
    }
    $("#search-results").append(`<div class="divider-legend">${item_count} ${item_type}</div>`)
    $.each(grouped[key], function (key, value) {
      let is_premium_module_offer = moment(new Date()).isBetween(new Date(value.premium_module_offer_from), new Date(value.premium_module_offer_to));
      var d_none = (key > 4) ? "d-none" : ""
      var link_to = "";
      switch (value.kind) {
        case "Artikel":
          link_to = `/neues/${value.lw_id}?ort=${current_ort_id}`
          break;
        case "Poi":
          link_to = `/entdecken/all/${value.lw_id}`
          break;
        case "Job":
          link_to = `/stellenangebote/${value.lw_id}`
          break;
        case "Veranstaltung":
          link_to = `/events/${value.lw_id}`
          break;
      }
      $("#search-results").append(`<li class="row mt-3 ${d_none}" data-count="${key}" data-type="${value.kind}" data-published="${value.publication_date}">
      <a class="align-items-center d-flex link-dark text-decoration-none" href="${link_to}"><div class="col-10">
      <div class="row">
        <p class="fs-small mb-0 ps-2 pt-1 text-black-50">${value.header}</p>
      </div>
      <div class="row">
        <div class="d-flex"><p class="mb-0 ps-2 fw-bold">${value.title}</p>
        ${ value.is_premium == 'true' ? `<div class="col-2 ps-4">
          <div class="row justify-content-end">
          <div class="col-10 p-0">
          <img src="/icons/button-premium.svg">
          </div>
          ${ is_premium_module_offer ? `<div class="col-2 p-0">
          <img src="/icons/button-premium-angebot.svg">
          </div>`: ''}
          </div>
        </div>` : ''}
        </div>
      </div>
      </div>
      <div class="col-2 d-flex justify-content-end pe-0">
      <div class="icon-arrow-right-1 text-default-gray"></div>
      </div>
      </a>
      </li>`);
    });
    item_count > 4 && $("#search-results").append(`<a class="d-flex justify-content-center pt-3 text-default-gray c-pointer" data-srcbtn data-id="${key}">Mehr anzeigen</a>`)
  });

}
const groupBy = (arr, key) => {
  const initialValue = {};
  return arr.reduce((acc, cval) => {
    const myAttribute = cval[key];
    acc[myAttribute] = [...(acc[myAttribute] || []), cval]
    return acc;
  }, initialValue);
};

async function getSuggestions(search) {
  const response = await fetch('/search-all?search=' + encodeURIComponent(search), {
    method: 'get',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  }).then(res => res.clone().json())
  return response;
}
